(function() {
    //_.templateSettings = {
    //    evaluate: /<%([\s\S]+?)%>/g,
    //    interpolate: /<%=([\s\S]+?)%>/g,
    //    escape: /<%--([\s\S]+?)%>/g
    //};
    //escape using custom function
    var hasOwnProperty   = Object.prototype.hasOwnProperty,
        _defaults = _.defaults;

    _.mixin({
        defaults: function() {
            if(!_.isObject(arguments[0])) arguments[0] = {};
            return _defaults.apply(_, arguments)
        },
        pluck: function(list /* , ..., property */) {
            var values = [],
                collection,
                value;

            if(arguments.length) {
                collection = _.toArray(arguments).slice(1);
                if(this.isArray(collection[0])) collection = collection[0];
            }

            if(_.size(collection)) {
                _.each(list, function (item) {
                    _.each(collection, function (key) {
                        value = item[key];
                        if (fpUtil.isNull(value)) return;
                        values.push(value);
                    });
                });
            }

            return values;
        },
        pickValues: function(obj /* , ..., property */) {
            var values = [];
            if(!_.isObject(obj)) return values;

            var collection,
                value;
            if(arguments.length) {
                collection = _.toArray(arguments).slice(1);
                if(this.isArray(collection[0])) collection = collection[0];
            }

            _.each(collection, function(key) {
                value = obj[key];
                if(!fpUtil.isNull(value)) values.push(value);
            });

            return values;
        },
        has: function(obj, key) {
            if(fpUtil.isNull(obj)) return false;
            if(!_.isObject(key) || !_.size(key)) {
                return hasOwnProperty.call(obj, key);
            }

            //if key is an array return true if all keys exist on object
            var isArray = _.isArray(key);
            return fpUtil.isNull(_.find(key, function(value, key) {
                key = isArray ? value : key;
                return !_.has(obj, key);
            }));
        },
        hasAny: function(obj, key) {
            if(fpUtil.isNull(obj)) return false;
            if(!_.isObject(key) || !_.size(key)) {
                return hasOwnProperty.call(obj, key);
            }

            //if key is an array return true if any keys exist on object
            var isArray = _.isArray(key);
            return !fpUtil.isNull(_.find(key, function(value, key) {
                key = isArray ? value : key;
                return _.has(obj, key);
            }));
        },
        //returns true if array1 contains any values from array2
        arrayContainsAny: function(array1, array2) {
            var contains = false;
            _.find(array2, function(value) {
                if(_.contains(array1, value)) {
                    contains = true;
                    return true;
                }
            });
            return contains;
        },
        result: function(object, property, fallback) {
            var value = _.isFunction(object) ? object() : (object == null ? void 0 : object[property]);
            if (value === void 0) {
                value = fallback;
            }
            return _.isFunction(value) ? value.call(object) : value;
        },
        empty: function(value) {
            if(_.isArray(value)) value.length = 0;
            else {
                _.each(value, function(item, key) {
                    delete value[key];
                });
            }
            return value;
        },
        clean: function(value, callback) {
            if(_.isArray(value)) {
                var item;
                for(var n=0; n<value.length;n++) {
                    item = value[n];
                    if(_.isFunction(callback)) item = value[n] = callback(item);
                    if(fpUtil.isNullOrEmpty(item) || (_.isString(item) && !S(item).trim().s)) {
                        value.splice(n, 1);
                        n--;
                    }
                }
            }
            else {
                _.each(value, function(item, key) {
                    if(_.isFunction(callback)) item = value[key] = callback(item);
                    if(fpUtil.isNullOrEmpty(item) || (_.isString(item) && !S(item).trim().s)) {
                        delete value[key];
                    }
                });
            }
            return value;
        },
        remove: function(array, value) {
            if(!_.isArray(array)) return;

            var item,
                index = _.indexOf(array, value);

            if(index >= 0) {
                item = array[index];
                array.splice(index, 1);
            }
            return item;
        },
        removeWhere: function(array, attrs) {
            if(!_.isArray(array)) return;
            if(!_.isObject(attrs)) return;

            var item,
                index = _.findIndex(array, attrs);

            if(index >= 0) {
                item = array[index];
                array.splice(index, 1);
            }
            return item;
        },
        indexStringArray: function(array) {
            var returnValue = {};

            _.each(array, function(value) {
                if(!S(value).trim().s) return;

                returnValue[value] = value;
            });

            return returnValue;
        },
        join: function(list, options) {
            if(!_.isObject(list)) return '';

            options = _.isString(options) ? {delimiter: options} : _.getObject(options);
            var returnValue = '',
                delimiter = S.getString(options.delimiter, ','),
                isArray = _.isArray(list),
                unique = options.unique,
                hash = unique && {};

            _.each(list, function(value, key) {
                if(!isArray && options.key) value = key;
                else {
                    if (fpUtil.isNullOrEmpty(value)) return;
                    if (_.isObject(value)) {
                        value = _.has(value, options.key) ? value[options.key] : null;
                    }
                }

                value = S(value).trim().s;
                if(!value) return;
                if(unique) {
                    if(_.has(hash, value)) return;
                    hash[value] = 1;
                }
                if(returnValue) returnValue += delimiter;
                returnValue += value;
            });
            

            return returnValue;
        },
        //concat n arrays into array 1
        concat: function(array1 /* , ..., arrayN */) {
            if(!_.isArray(array1)) array1 = [];

            var arrayN;
            for(var n=1;n<arguments.length;n++) {
                arrayN = arguments[n];
                if(!_.isArray(arrayN)) continue;

                for(var z=0;z<arrayN.length;z++) {
                    array1.push(arrayN[z]);
                }
            }

            return array1;
        },
        move: function (array, fromIndex, toIndex) {
            array.splice(toIndex || 0, 0, array.splice(fromIndex, 1)[0]);
            return array;
        },
        getObject: function(value, defaultValue) {
            return _.isObject(value) ? value : (_.isObject(defaultValue) ? defaultValue : {});
        },
        isArrayLike: function(value) {
            return _.isObject(value) && value.length >= 0;
        },
        getArray: function(value, defaultValue) {
            return _.isArray(value) ? value : (_.isArray(defaultValue) ? defaultValue : []);
        },
        ensureArrayLike: function(value) {
            return _.isArrayLike(value) ? value : (fpUtil.isNull(value) ? [] : [value]);
        },
        getFunction: function(value, defaultValue) {
            return _.isFunction(value) ? value : (_.isFunction(defaultValue) ? defaultValue : $.noop);
        },
        firstObject: function(value, defaultValue) {
            value = _.isArray(value) ? _.first(value) : value;
            return _.getObject(value, defaultValue);
        },
        getCollectionValue: function(collection, value, defaultValue) {
            if(!fpUtil.isNull(value)) {
                if(_.size(collection)) {
                    if(_.findWhere(collection, {value: value})) return value;
                }
                else return value;
            }

            return defaultValue;
        },
        stringify: function(obj, options) {
            options = _.getObject(options);
            var exclude = _.getArray(options.exclude),
                value = '',
                isArray;

            if (_.isFunction(obj)) value += 'function()';
            else if(_.isBoolean(obj)) value += obj.toString();
            else if(_.isObject(obj)) {
                if(_.isDate(obj)) {
                    if(false && window.JSON) value = JSON.stringify(obj);
                    else value = obj.toString();

                    return value;
                }
                else if(_.isRegExp(obj)) {
                    value = '"' + obj.toString() + '"';

                    return value;

                }

                isArray =  _.isArray(obj);

                _.each(obj, function(item, key) {
                    if(!isArray && _.contains(exclude, key)) return;

                    if(value) value += ',';
                    if(!isArray) value += '"' + key + '":';

                    value += _.stringify(item, options);
                });

                if(isArray) value = '[' + value + ']';
                else value = '{' + value + '}';
            }
            else {
                if(_.isUndefined(obj)) value = 'undefined';
                else if(_.isNull(obj)) value = 'null';
                else value = '"' + obj.toString() + '"';
            }

            return value;
        },
        //function will extend/merge an array of objects based off of key
        extendObjectArray: function(array1, array2, key) {
            if(_.isArray(array1) && _.isArray(array2) && array1.length && array2.length && key) {
                const hashedArray2 = _.indexBy(array2, key),
                    array2KeyedValues = {};
                _.each(array1, function(obj1) {
                    if(_.isObject(obj1)) {
                        const keyedValue = obj1[key],
                            obj2 = hashedArray2[keyedValue];
                        if(_.isObject(obj2)) {
                            array2KeyedValues[keyedValue] = 1;
                            _.extend(obj1, obj2);
                        }
                    }
                });

                if(_.size(array2KeyedValues) !== array2.length) {
                    _.each(array2, function(obj) {
                        if(_.isObject(obj)) {
                            const keyedValue = obj[key];
                            if(!array2KeyedValues[keyedValue]) {
                                array1.push(obj);
                            }
                        }
                    });
                }
            }
            return array1;
        }
    });
})();